<template>
	<div class='roadmap-section py-5'>
		<div class='container'>
			<div class='row text-center'>
				<div class='col-12'>
					<h1 class="headline-l mb-4 title">
						{{ $t("aboutUsScreen.roadmap.title") }}
					</h1>
					<p class="text-l description mx-auto" v-html="$t('aboutUsScreen.roadmap.description')" />
					<div class="flex justify-content-center">
						<base-button class="jumbotron-button mx-3" :text="$t('aboutUsScreen.roadmap.button2026')"
							:size="'large'" @clicked="() => {
								handleNewButtonClick()
							}" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RoadMap',
	methods: {
		handleOldButtonClick() {
			const shortCodeToLangCode = {
				hu: 'hu',
				en: 'eng',
			}
			const link = `http://data.blockben.com/roadmap/blockben_roadmap_${shortCodeToLangCode[this.$i18n.locale || 'en']}.pdf`;
			window.open(link, '_blank');
		},
		handleNewButtonClick() {
			let link;
			switch (this.$i18n.locale) {
				case 'en':
					link = 'https://data.blockben.com/roadmap/roadmap_en.pdf';
					break;
				case 'hu':
					link = 'https://data.blockben.com/roadmap/roadmap_hu.pdf';
					break;
				case 'lv':
					link = 'https://data.blockben.com/roadmap/roadmap_lv.pdf';
					break;
				default:
					link = 'https://data.blockben.com/roadmap/roadmap_en.pdf';
			}
			window.open(link, '_blank');
		}
	}
};
</script>

<style lang='scss' scoped>
.roadmap-section {
	background-color: $lighter-purple;
	padding-bottom: 80px;
	padding-top: 80px;
	margin-bottom: 90px;

	.title {
		color: $primary-purple;
	}

	.description {
		max-width: 730px;
		text-align: center;
		margin-bottom: 48px;

		@media (max-width: $breakpoint-sm) {
			margin-bottom: 65px;
		}
	}
}
</style>
